
const ISOs = { 
  639: 'ISO639',
  CC: 'ISOCountryCode',
  3166: 'ISO3166'
};
export default class Locale {
  constructor( locale ) {
    this.locale = locale;

    if(this.locale.includes('_')) {
      this.is = ISOs[3166];
    } else if (this.locale.includes('-')) {
      this.is = ISOs['CC'];
    } else {
      this.is = ISOs[639];
    }
  }


  toISO3166() {
    let ret = this.locale;

    if(this.is === ISOs[639]) {
      ret = this.locale.split('-').join('_');
    }

    return ret;
  }

  toISOCountryCode() {
    let ret = this.locale;

    if(this.is === ISOs['3166']) {
      ret = this.locale.split('_').join('-');
    }

    return ret;
  }

  toISO639(){    
    let ret = this.locale;
    
    
    if(this.is === ISOs[3166]) {
      ret = this.locale.split('_')[0];
    } else if(this.is === ISOs[639]) {
      ret = this.locale.split('-')[0];
    }

    return ret;
  }
}